import questionTypes from '../questionTypes';
import createEmptyOptionCollection from '../../utils/createEmptyOptionCollection';
import getCommonBlockProps from './getCommonBlockProps';
import { DEFAULT_ROW_LABEL, DEFAULT_MAX_OPTIONS_COUNT } from './constants';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentInfoDropdown,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    options: createEmptyOptionCollection(1, DEFAULT_ROW_LABEL),
    label: 'Select option',
    labelEnabled: true,
  }),
  limits: {
    options: {
      max: DEFAULT_MAX_OPTIONS_COUNT,
      min: 1,
    },
  },
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
};
